import { Flex } from '@rango-dev/whale';
import React from 'react';

import { useAppSelector } from '../hooks/reduxHooks';

import { Analytics } from './Analytics';

const ServerStatus = (): JSX.Element => {
  const status = useAppSelector((state) => state.status.status);

  if (!status) {
    return <React.Fragment />;
  }

  return (
    <Flex display={{ initial: 'none', xl: 'flex' }} width="100%" justify="center">
      <Flex
        direction="column"
        width={{ initial: '32rem', lg: '20rem' }}
        position={{ lg: 'absolute' }}
        top={{ sm: '0' }}
        left={{ sm: '8px' }}>
        <Analytics />
      </Flex>
    </Flex>
  );
};

export default ServerStatus;
